module.exports = __webpack_public_path__ + "img/4a1ae8113cc697405c7a6b07df7a2ce.4b227b01.png";